import { StyleSheet } from 'react-native';
import { themes } from 'src/theme/theme';

export const styles = StyleSheet.create({
  overlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 9,
  },
  floatingButton: {
    position: 'absolute',
    bottom: 90,
    right: 0,
    backgroundColor: themes.light.brand_blue[3],
    paddingVertical: 20,
    paddingLeft: 30,
    paddingRight: 10,
    borderTopLeftRadius: 30,
    borderBottomLeftRadius: 30,
    elevation: 5, // For Android shadow
    zIndex: 10, // For iOS shadow
  },
  buttonText: {
    color: themes.light.white[1],
    fontWeight: 'bold',
    fontSize: 16,
    textAlign: 'center',
  },
  expandedContainer: {
    position: 'absolute',
    bottom: 90,
    right: 0,
    backgroundColor: themes.light.brand_blue[3],
    padding: 15,
    borderTopLeftRadius: 10,
    borderBottomLeftRadius: 10,
    elevation: 5, // For Android shadow
    zIndex: 10, // For iOS shadow
  },
  placeholderText: {
    color: themes.light.white[1],
    fontSize: 14,
    textAlign: 'center',
  },
  carrierListItem: {
    paddingVertical: 5,
  },
  carrierText: {
    fontSize: 16,
    fontWeight: '500',
    color: themes.light.white[1],
    textAlign: 'left',
  },
});
